// extracted by mini-css-extract-plugin
export default {"display-mode":"styles_display-mode__H6Z5O"};